<template>
<div class="chapter">
<div class="inner_page">
<p class="cont"><b>CONTENTS</b></p>
<p class="toc"><a href="#/acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">A Few Words about Language and Paranormal Investigation</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">A Little Background History of Marietta</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">About the Nature of Ghosts</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">A Historical Marietta Ghost Story</span></p>
<p class="toc"><span href="#/chapter05" title="Link target outside of Sample">Shades of the Civil War</span></p>
<p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Cemetery Shades</span></p>
<p class="toc"><span href="#/chapter07" title="Link target outside of Sample">Haunted Bridges</span></p>
<p class="toc"><span href="#/chapter08" title="Link target outside of Sample">Shades of the Square</span></p>
<p class="toc"><span href="#/chapter09" title="Link target outside of Sample">Haunted Houses and Buildings</span></p>
<p class="toc"><span href="#/chapter10" title="Link target outside of Sample">A Contemporary Marietta Ghost Story</span></p>
<p class="toc1"><span href="#/conclusion" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/appendix" title="Link target outside of Sample">Appendix. Visit Some of these Places and Learn More about Marietta</span></p>
<p class="toc"><span href="#/bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/abouttheauthor" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?580bb4d6